export default __webpack_public_path__ + "static/media/germany.ac7785dc.svg";